import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Play, ArrowRight, ChevronRight } from "lucide-react";
import { IMAGES, HERO_FLOW } from "@/lib/content";

export const Hero = () => {
  return (
    <section className="relative min-h-[100svh] flex items-center overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0">
        <img src={IMAGES.hero} alt="Tropical planted aquarium" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-base via-brand-base/85 to-brand-base/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-base via-transparent to-brand-base/60" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 lg:px-8 w-full pt-52 pb-16">
        <div className="max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="accent-label">The Fish House Project · Episode 01</span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="mt-5 font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-white text-glow"
          >
            CAN I TURN MY FISH HOBBY INTO A BUSINESS?
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="mt-6 text-brand-textSec text-base sm:text-lg leading-relaxed max-w-2xl"
          >
            I'm starting with a few tanks around my house, building my first fish room,
            experimenting with breeding and trying to turn a passion for tropical fish into a real business.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="mt-9 flex flex-col sm:flex-row gap-4"
          >
            <Link to="/journey" className="btn-primary px-7 py-3.5 text-sm inline-flex items-center justify-center gap-2" data-testid="watch-journey-btn">
              <Play size={17} className="fill-current" /> Watch the Journey
            </Link>
            <Link to="/community" className="btn-ghost px-7 py-3.5 text-sm inline-flex items-center justify-center gap-2" data-testid="join-project-btn">
              Join the Project <ArrowRight size={16} />
            </Link>
          </motion.div>
        </div>
      </div>

      {/* Journey flow indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.5 }}
        className="absolute bottom-8 inset-x-0 z-10"
      >
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="flex items-center gap-2 sm:gap-3 flex-wrap text-xs sm:text-sm">
            {HERO_FLOW.map((step, i) => (
              <span key={step} className="flex items-center gap-2 sm:gap-3">
                <span className={`font-display font-semibold tracking-wide ${i === 0 ? "text-brand-cyan" : "text-brand-textSec"}`}>
                  {step.toUpperCase()}
                </span>
                {i < HERO_FLOW.length - 1 && <ChevronRight size={14} className="text-brand-textMuted" />}
              </span>
            ))}
          </div>
        </div>
      </motion.div>
    </section>
  );
};
